/* Jonathan Snook - MIT License - https://github.com/snookca/prepareTransition */
(function(a){a.fn.prepareTransition=function(){return this.each(function(){var b=a(this);b.one("TransitionEnd webkitTransitionEnd transitionend oTransitionEnd",function(){b.removeClass("is-transitioning")});var c=["transition-duration","-moz-transition-duration","-webkit-transition-duration","-o-transition-duration"];var d=0;a.each(c,function(a,c){d=parseFloat(b.css(c))||d});if(d!=0){b.addClass("is-transitioning");b[0].offsetWidth}})}})(jQuery);

/* replaceUrlParam - http://stackoverflow.com/questions/7171099/how-to-replace-url-parameter-with-javascript-jquery */
function replaceUrlParam(e,r,a){var n=new RegExp("("+r+"=).*?(&|$)"),c=e;return c=e.search(n)>=0?e.replace(n,"$1"+a+"$2"):c+(c.indexOf("?")>0?"&":"?")+r+"="+a};

/*============================================================================
  Money Format
  - Shopify.format money is defined in option_selection.js.
    If that file is not included, it is redefined here.
==============================================================================*/
if ((typeof Shopify) === 'undefined') { Shopify = {}; }
if (!Shopify.formatMoney) {
  Shopify.formatMoney = function(cents, format) {
    var value = '',
        placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
        formatString = (format || this.money_format);

    if (typeof cents == 'string') {
      cents = cents.replace('.','');
    }

    function defaultOption(opt, def) {
      return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal   = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number/100.0).toFixed(precision);

      var parts   = number.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          cents   = parts[1] ? (decimal + parts[1]) : '';

      return dollars + cents;
    }

    switch(formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  };
}

// Timber functions
window.timber = window.timber || {};

timber.cacheSelectors = function () {
  timber.cache = {
    // General
    $html                    : $('html'),
    $body                    : $(document.body),

    // Navigation
    $navigation              : $('#AccessibleNav'),
    $mobileSubNavToggle      : $('.mobile-nav__toggle'),

    // Collection Pages
    $changeView              : $('.change-view'),

    // Product Page
    $productImage            : $('#ProductPhotoImg'),
    $thumbImages             : $('#ProductThumbs').find('a.product-single__thumbnail'),

    // Customer Pages
    $recoverPasswordLink     : $('#RecoverPassword'),
    $hideRecoverPasswordLink : $('#HideRecoverPasswordLink'),
    $recoverPasswordForm     : $('#RecoverPasswordForm'),
    $customerLoginForm       : $('#CustomerLoginForm'),
    $passwordResetSuccess    : $('#ResetSuccess'),
	$product_sku : $('.variant-sku')
  };
};

timber.init = function () {
  FastClick.attach(document.body);
  timber.cacheSelectors();
  timber.accessibleNav();
  timber.drawersInit();
  timber.mobileNavToggle();
  timber.productImageSwitch();
  timber.responsiveVideos();
  timber.collectionViews();
  timber.loginForms();
  timber._initProductDescription();
};

timber.accessibleNav = function () {
  var $nav = timber.cache.$navigation,
      $allLinks = $nav.find('a'),
      $topLevel = $nav.children('li').find('a'),
      $parents = $nav.find('.site-nav--has-dropdown'),
      $subMenuLinks = $nav.find('.site-nav__dropdown').find('a'),
      activeClass = 'nav-hover',
      focusClass = 'nav-focus';
// bof - ASP-41
  // Mouseenter
  $nav.on('mouseenter touchstart', '.site-nav--has-dropdown', function(evt) {
    var $el = $(this);
    if ($el.hasClass(activeClass)){
      evt.stopPropagation();
      return true;
    }
    if ( !($el.hasClass(activeClass) || $el.find('.site-nav__dropdown').length == 0) ) {
      evt.preventDefault();
    }

    showDropdown($el);
  });

  // Mouseout
  $nav.on('mouseleave', '.site-nav--has-dropdown', function() {
    hideDropdown($(this));
  });
// eof - ASP-41

  $subMenuLinks.on('touchstart', function(evt) {
    // Prevent touchstart on body from firing instead of link
    evt.stopImmediatePropagation();
  });

  $allLinks.focus(function() {
    handleFocus($(this));
  });

  $allLinks.blur(function() {
    removeFocus($topLevel);
  });

  // accessibleNav private methods
  function handleFocus ($el) {
    var $subMenu = $el.next('ul'),
        hasSubMenu = $subMenu.hasClass('sub-nav') ? true : false,
        isSubItem = $('.site-nav__dropdown').has($el).length,
        $newFocus = null;

    // Add focus class for top level items, or keep menu shown
    if (!isSubItem) {
      removeFocus($topLevel);
      addFocus($el);
    } else {
      $newFocus = $el.closest('.site-nav--has-dropdown').find('a');
      addFocus($newFocus);
    }
  }

  function showDropdown ($el) {
    $el.addClass(activeClass);

    setTimeout(function() {
      timber.cache.$body.on('touchstart', function() {
        hideDropdown($el);
      });
    }, 250);
  }

  function hideDropdown ($el) {
    $el.removeClass(activeClass);
    timber.cache.$body.off('touchstart');
  }

  function addFocus ($el) {
    $el.addClass(focusClass);
  }

  function removeFocus ($el) {
    $el.removeClass(focusClass);
  }
};

timber.drawersInit = function () {
  timber.LeftDrawer = new timber.Drawers('NavDrawer', 'left');
  
};

// bof - ASP-41
timber.mobileNavToggle = function () {
  let parent = timber.cache.$mobileSubNavToggle.parent();
  parent.on('click', function(e) {
    let elm = $(this);
    let isOpen = elm.hasClass('mobile-nav--expanded');
    elm.toggleClass('mobile-nav--expanded');
    if (isOpen) {
      return true;
    }
    else {
      e.preventDefault();
      $('#AccessibleNav').animate({
        scrollTop: elm.offset().top
	  }, 1000);
      return false;
    }
  });
};
// eof - ASP-41

timber.getHash = function () {
  return window.location.hash;
};

//ASP-90: count variable to detect page load
var change_img_count = 0;
timber.productPage = function (options) {
  var moneyFormat = options.money_format,
      variant = options.variant,
      selector = options.selector;

  // Selectors
  var $productImage = $('#ProductPhotoImg'),
      $addToCart = $('#AddToCart'),
      $productPrice = $('#ProductPrice'),
      $comparePrice = $('#ComparePrice'),
      $quantityElements = $('.quantity-selector, label + .js-qty'),
      $addToCartText = $('#AddToCartText');
  
  if (variant) {
    $('.variant-sku').text(variant.sku);
    $('#variant-stockstatus').attr('data-id',variant.id);
    //console.log( $('#variant-stockstatus').attr('data-id') );
    
    //ASP-90: change to variant when input is interacted with
    if (variant.featured_image && change_img_count > 0) {
      var newImg = variant.featured_image,
          el = $productImage[0];
      	Shopify.Image.switchImage(newImg, el, timber.switchImage);
    }

    // Select a valid variant if available
    if (variant.available) {
      // Available, enable the submit button, change text, show quantity elements
      $addToCart.removeClass('disabled').prop('disabled', false);
      $addToCartText.html("Add to Cart");
      $quantityElements.show();
    } else {
      // Sold out, disable the submit button, change text, hide quantity elements
      $addToCart.addClass('disabled').prop('disabled', true);
      $addToCartText.html("out of stock");
      $quantityElements.hide();
    }

    // Regardless of stock, update the product price
    $productPrice.html( Shopify.formatMoney(variant.price, moneyFormat) );

    // Also update and show the product's compare price if necessary
    if (variant.compare_at_price > variant.price) {
      $comparePrice
        .html("" + ' ' + Shopify.formatMoney(variant.compare_at_price, moneyFormat))
        .show();
    } else {
      $comparePrice.hide();
    }

  } else {
    // The variant doesn't exist, disable submit button.
    // This may be an error or notice that a specific variant is not available.
    // To only show available variants, implement linked product options:
    //   - http://docs.shopify.com/manual/configuration/store-customization/advanced-navigation/linked-product-options
    $addToCart.addClass('disabled').prop('disabled', true);
    $addToCartText.html("Unavailable");
    $quantityElements.hide();
  }
  
};

timber.productImageSwitch = function () {
  if (timber.cache.$thumbImages.length) {
    // Switch the main image with one of the thumbnails
    // Note: this does not change the variant selected, just the image
    timber.cache.$thumbImages.on('click', function(evt) {
      evt.preventDefault();
      var newImage = $(this).attr('href');
      timber.switchImage(newImage, null, timber.cache.$productImage);
    });
  }
};

timber.switchImage = function (src, imgObject, el) {
  // Make sure element is a jquery object
  var $el = $(el);
  $el.attr('src', src);
  $el.attr('data-image-zoom', src);
  
  $('#ProductPhotoImg').remove();
  $('.zoomContainer').remove();
    
  $('#FeaturedImageZoom-product-template').append('<img src="'+src+'" alt="" id="ProductPhotoImg" data-zoom-image="'+src.replace('large.jpg', '2000x2000.jpg')+'" width="75%" height="100%">');       
  $("#ProductPhotoImg").elevateZoom({
      borderSize : 1,
      borderColour: "#ddd",
      lensSize: 150
  });
};

timber.responsiveVideos = function () {
  var $iframeVideo = $('iframe[src*="youtube.com/embed"], iframe[src*="player.vimeo"]');
  var $iframeReset = $iframeVideo.add('iframe#admin_bar_iframe');

  $iframeVideo.each(function () {
    // Add wrapper to make video responsive
    $(this).wrap('<div class="video-wrapper"></div>');
  });

  $iframeReset.each(function () {
    // Re-set the src attribute on each iframe after page load
    // for Chrome's "incorrect iFrame content on 'back'" bug.
    // https://code.google.com/p/chromium/issues/detail?id=395791
    // Need to specifically target video and admin bar
    this.src = this.src;
  });
};

timber.collectionViews = function () {
  if (timber.cache.$changeView.length) {
    timber.cache.$changeView.on('click', function() {
      var view = $(this).data('view'),
          url = document.URL,
          hasParams = url.indexOf('?') > -1;

      if (hasParams) {
        window.location = replaceUrlParam(url, 'view', view);
      } else {
        window.location = url + '?view=' + view;
      }
    });
  }
};

timber.loginForms = function() {
  function showRecoverPasswordForm() {
    timber.cache.$recoverPasswordForm.show();
    timber.cache.$customerLoginForm.hide();
  }

  function hideRecoverPasswordForm() {
    timber.cache.$recoverPasswordForm.hide();
    timber.cache.$customerLoginForm.show();
  }

  timber.cache.$recoverPasswordLink.on('click', function(evt) {
    evt.preventDefault();
    showRecoverPasswordForm();
  });

  timber.cache.$hideRecoverPasswordLink.on('click', function(evt) {
    evt.preventDefault();
    hideRecoverPasswordForm();
  });

  // Allow deep linking to recover password form
  if (timber.getHash() == '#recover') {
    showRecoverPasswordForm();
  }
};

timber.resetPasswordSuccess = function() {
  timber.cache.$passwordResetSuccess.show();
};


timber._initProductDescription = function(){
  //Add cLass to current list containing the content for tabs
  $('.product-single__description > ul').addClass('tab-content');

  var datavalues = ['description','size-chart'];
  $('.product-single__description > ul>li').each(function(index){
    $(this).attr('id',datavalues[index]);
  });

  //Append tab titles
  var titles = "<ul class='tab-titles'><li class='active' data-tab='description'>Description</li><li data-tab='specification'>Specifications</li><li data-tab='accessories-tab'>Accessories</li><li data-tab='reviews'>Reviews</li></ul>";
  $('.product-single__description').prepend(titles);

  //Add click function
  $('.tab-titles > li').click(function(){
    var tab = $(this).data('tab');
    $('.tab-content > li').hide();
    $('.tab-titles > li').removeClass('active');
    $(this).addClass('active');
    $('.tab-content > li#'+tab).show();
  });
}

/*============================================================================
  Drawer modules
  - Docs http://shopify.github.io/Timber/#drawers
==============================================================================*/
timber.Drawers = (function () {
  var Drawer = function (id, position, options) {
    var defaults = {
      close: '.js-drawer-close',
      open: '.js-drawer-open-' + position,
      openClass: 'js-drawer-open',
      dirOpenClass: 'js-drawer-open-' + position
    };

    this.$nodes = {
      parent: $('body, html'),
      page: $('#PageContainer'),
      moved: $('.is-moved-by-drawer')
    };

    this.config = $.extend(defaults, options);
    this.position = position;

    this.$drawer = $('#' + id);

    if (!this.$drawer.length) {
      return false;
    }

    this.drawerIsOpen = false;
    this.init();
  };

  Drawer.prototype.init = function () {
    $(this.config.open).on('click', $.proxy(this.open, this));
    this.$drawer.find(this.config.close).on('click', $.proxy(this.close, this));
  };

  Drawer.prototype.open = function (evt) {
    // Keep track if drawer was opened from a click, or called by another function
    var externalCall = false;

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the drawer opens, the click event bubbles up to $nodes.page
    // which closes the drawer.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.drawerIsOpen && !externalCall) {
      return this.close();
    }

    // Notify the drawer is going to open
    timber.cache.$body.trigger('beforeDrawerOpen.timber', this);

    // Add is-transitioning class to moved elements on open so drawer can have
    // transition for close animation
    this.$nodes.moved.addClass('is-transitioning');
    this.$drawer.prepareTransition();

    this.$nodes.parent.addClass(this.config.openClass + ' ' + this.config.dirOpenClass);
    this.drawerIsOpen = true;

    // Set focus on drawer
    this.trapFocus(this.$drawer, 'drawer_focus');

    // Run function when draw opens if set
    if (this.config.onDrawerOpen && typeof(this.config.onDrawerOpen) == 'function') {
      if (!externalCall) {
        this.config.onDrawerOpen();
      }
    }

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true');
    }

    // Lock scrolling on mobile
    this.$nodes.page.on('touchmove.drawer', function () {
      return false;
    });

    this.$nodes.page.on('click.drawer', $.proxy(function () {
      this.close();
      return false;
    }, this));

    // Notify the drawer has opened
    timber.cache.$body.trigger('afterDrawerOpen.timber', this);
  };

  Drawer.prototype.close = function () {
    if (!this.drawerIsOpen) { // don't close a closed drawer
      return;
    }

    // Notify the drawer is going to close
    timber.cache.$body.trigger('beforeDrawerClose.timber', this);

    // deselect any focused form elements
    $(document.activeElement).trigger('blur');

    // Ensure closing transition is applied to moved elements, like the nav
    this.$nodes.moved.prepareTransition({ disableExisting: true });
    this.$drawer.prepareTransition({ disableExisting: true });

    this.$nodes.parent.removeClass(this.config.dirOpenClass + ' ' + this.config.openClass);

    this.drawerIsOpen = false;

    // Remove focus on drawer
    this.removeTrapFocus(this.$drawer, 'drawer_focus');

    this.$nodes.page.off('.drawer');

    // Notify the drawer is closed now
    timber.cache.$body.trigger('afterDrawerClose.timber', this);
  };

  Drawer.prototype.trapFocus = function ($container, eventNamespace) {
    var eventName = eventNamespace ? 'focusin.' + eventNamespace : 'focusin';

    $container.attr('tabindex', '-1');

    $container.focus();

    $(document).on(eventName, function (evt) {
      if ($container[0] !== evt.target && !$container.has(evt.target).length) {
        $container.focus();
      }
    });
  };

  Drawer.prototype.removeTrapFocus = function ($container, eventNamespace) {
    var eventName = eventNamespace ? 'focusin.' + eventNamespace : 'focusin';

    $container.removeAttr('tabindex');
    $(document).off(eventName);
  };

  return Drawer;
})();

// Initialize Timber's JS on docready
$(timber.init);

$(document).ready(function() {

  $('.faq-question').on('click', function(){

    if( $(this).parent().hasClass('active') ){
      $(this).parent().siblings('.faq-accord').removeClass('active').children('.faq-answer').slideUp(150);
      $(this).next().slideUp(150).parent().removeClass('active');
    } else {

      $(this).parent().siblings('.faq-accord').removeClass('active').children('.faq-answer').slideUp(150);
      $(this).parent().addClass('active');
      $(this).next().slideDown(200, function() {
          $('html, body').delay('200').animate({
          scrollTop: $(this).offset().top - 350
          }, 200);
      });

    }

    
  });

  $('button.btn--link.site-header__menu').on('click', function(){
    if( $('nav#AccessibleNav').is(':hidden') ){
      $(this).addClass('mobile-nav--close');
      $('nav#AccessibleNav').slideDown('fast', 'swing', function() {}).removeClass('show_menu_on_desktop');
    } else{
      $(this).removeClass('mobile-nav--close');
      $('nav#AccessibleNav').slideUp('fast', 'swing', function() {}).addClass('show_menu_on_desktop');
    }
  });

  $('.engraving-enable-box').on('click', function(){

    if( $('#engrave-this-product-radio').is(':checked') ){
      $('.engrave-main-settings').slideUp(300);
      $('.entry.buttons').slideDown(300);
      $('.engraving-entry-wrapper').addClass('enabled');
    } else{
      $('.engrave-main-settings').slideDown(300);
      $('.engraving-entry-wrapper').removeClass('enabled');
      $('.entry.buttons').fadeOut(300);
    }

  });

  $('.engrave-details-final h3 a.edit').on('click', function(e){
      $('.engrave-main-settings,.main-buttons-section').slideUp(300);
      $('.entry.buttons').slideDown(300);
      $('.engraving-entry-wrapper').addClass('enabled');
      e.preventDefault();
  });

  // ASP-96: moved to engrave-js

    //$('.search-bar input:text[value=""]:visible:enabled:first').focus();


    $('.swatch-element').hover( function(){
      console.log ( $(this).data('variant-image') );
      $(this).parent().siblings('.grid-view-item__image').attr( 'src',$(this).data('variant-image') );
    }, function(){
      $(this).parent().siblings('.grid-view-item__image').attr( 'src',$(this).data('variant-image') );
      console.log('test out');
    });


    $('.filters-toolbar__input').on('change', function(){
      window.location.href = $('#collection-url-to-filter').val() + '?sort_by=' + $(this).val();
    });


    $('.search-header__submit').on('click', function(e){



      if( $('.site-header__search').hasClass('search-focus') ){
        console.log($('.search-header__input.search__input').val());
        if($('.search-header__input.search__input').val() == '' ){
          $('.site-header__search').removeClass('search-focus');
          $('.site-header .main-wrapper .search-header').removeClass('search--focus');
          console.log('no val');
        } else {
        console.log('with val');
        return true;
        }
        console.log('outside if');
      } else{
        console.log('else');
        $('.site-header__search').addClass('search-focus');
        $('.site-header .main-wrapper .search-header').addClass('search--focus');

        $('.search-header__input').focus();

      }

      e.preventDefault();

    });

    $(document).click(function(event) {

      if (window.matchMedia('(max-width:1150px)').matches && window.matchMedia('(min-width:980px)').matches){
        $('.site-header__search').addClass('search-focus');
        $('.site-header .main-wrapper .search-header').addClass('search--focus');
      } else {
        if(!$(event.target).closest('.site-header__search').length) {
            $('.site-header__search').removeClass('search-focus');
            $('.site-header .main-wrapper .search-header').removeClass('search--focus');
        }
      }
    });


    $('.meta-product-share a.share').on('click', function(e){
      e.preventDefault();
      $('.social').toggleClass('active');
    });
    /*
    if (window.matchMedia('(min-width: 970px)').matches){
        $('.site-header__search').addClass('search-focus');
        $('.site-header .main-wrapper .search-header').addClass('search--focus');
    }
    */

    if (window.matchMedia('(max-width: 950px)').matches){
        $('.site-header__search').removeClass('search-focus');
        $('.site-header .main-wrapper .search-header').removeClass('search--focus');
    }

    if (window.matchMedia('(max-width: 1150px)').matches){
        $('#AccessibleNav').height( $(window).height() - $('.header-section').height() ).css('overflow-y','scroll');
    }

    $('#AddToCartForm').submit(function() {
      console.log($('#eface').val());
        var product_engrave_font = $('#eface').val();
        if( product_engrave_font ){
          if( product_engrave_font == 'arial' ){ $('#eface').append('<option value="Block">Block</option>'); $('#eface').val('Block'); console.log('1'); }
          else if( product_engrave_font == 'times' ){ $('#eface').append('<option value="Serif">Serif</option>'); $('#eface').val('Serif'); }
          else if( product_engrave_font == 'lucida' ){ $('#eface').append('<option value="Script">Script</option>'); $('#eface').val('Script'); console.log('3'); }
          else{}
        }
        return true;
    });


    $('.pdf-table-tabs li a').on('click', function(e){
      $('.pdf-table-tabs li').removeClass('active');
      $(this).parent().addClass('active');

      $('.tabled.pdf-table > li').css('display','none');
      $('.grid_layout.pdf-table li').removeClass('display_important');
      $('.tabled.pdf-table li.'+ $(this).data('type') ).css('display','block');
      e.preventDefault();
    });

    $('#pdftable-control-table').on('click', function(e){
        e.preventDefault();
        $('#top-scroll-bar-wrapper').css('visibility','visible');
        $('.slide-to-see-right').css('display','block');
        $('.instruction-pdftable').removeClass('hide');
        $('#pdftable-control-grid').removeClass('active');
        $('#pdftable-control-table').addClass('active');
        $('.pdf-table-tabs').css('display','none');
        $('ul.pdf-table-display.pdf-table').removeClass('tabled').addClass('grid_layout');
        $('#mobile-list-spec').removeClass('hide');
        $('#sticky-header-light-matrix').removeClass('hide');

            if( $('#main-pdftable-list').parent().is('div.pdf-table-mobile-wrapper')){} else{

            if($('#sticky-header-light-matrix').hasClass('remove-li-activate') ){
                // do nothing
            } else {
                // ---
                // ASP-19 :: Fix Flashlight Feature Comparison Table
                // createBarTitles();
                // getBarTableTitlesWidths();
                // end/ASP-19
            }
            var total_li_width = 0;
            $('#main-pdftable-list li.product-list').each( function(){
                total_li_width += $(this).width();
            });

            $('#main-pdftable-list').width(total_li_width+1).wrap('<div class="pdf-table-mobile-wrapper"></div>');
            $('#top-scroll-bar-pdf').width(total_li_width+3);

            if( $('#slide-to-see-right').hasClass('reload-active') ){ } else{
                $('#slide-to-see-right').append('<a href="" javascript="window.reload()">Reset Chart</a>');
            }
            $('#slide-to-see-right').addClass('reload-active');
            }

        $('.spec-table-title .spec-question-mark').hover(
            function(){
            if( $(this).parent().find('.description').text() ){
                $(this).parent().append('<div class="appended-desc">'+$(this).parent().find('.description').text()+'</div>');
            }
            },
            function(){ $('.appended-desc').remove(); }
        );

        $(".pdf-table-mobile-wrapper").scroll(function(){
            $("#sticky-header-light-matrix").scrollLeft($(".pdf-table-mobile-wrapper").scrollLeft());
            $("#top-scroll-bar-wrapper").scrollLeft($(".pdf-table-mobile-wrapper").scrollLeft());
        });
        $("#sticky-header-light-matrix").scroll(function(){
            $(".pdf-table-mobile-wrapper").scrollLeft($("#sticky-header-light-matrix").scrollLeft());
            $("#top-scroll-bar-wrapper").scrollLeft($("#sticky-header-light-matrix").scrollLeft());
        });
        $("#top-scroll-bar-wrapper").scroll(function(){
            $(".pdf-table-mobile-wrapper").scrollLeft($("#top-scroll-bar-wrapper").scrollLeft());
            $("#sticky-header-light-matrix").scrollLeft($("#top-scroll-bar-wrapper").scrollLeft());
        });

    });


    $('#pdftable-control-grid').on('click', function(e){
        $('#top-scroll-bar-wrapper').css('visibility', 'hidden');
        $('.slide-to-see-right').css('display', 'none');
        $('.instruction-pdftable').addClass('hide');
        $('#sticky-header-light-matrix').addClass('hide');
        $('#mobile-list-spec').addClass('hide');
        $('#pdftable-control-table').removeClass('active');
        $('#pdftable-control-grid').addClass('active');
        $('.container-container').remove();
        // $('.clone-pdf-table-title').remove();
        $('#main-pdftable-list').removeAttr('style').css({ 'display':'block'});
        $('.pdf-table-tabs').css('display','block');
        $('ul.pdf-table-display.pdf-table').removeClass('grid_layout').addClass('tabled');

        if( $('#main-pdftable-list').parent().is('div.pdf-table-mobile-wrapper')){
          $('#main-pdftable-list').unwrap('.pdf-table-mobile-wrapper');
        }
        e.preventDefault();
    });



    $(window).resize(function(event) {
      if ( window.matchMedia('(max-width: 1150px)').matches){
          $('.site-header__search').addClass('search-focus');
          $('.site-header .main-wrapper .search-header').addClass('search--focus');
      } else{
          $('.site-header__search').removeClass('search-focus');
          $('.site-header .main-wrapper .search-header').removeClass('search--focus');
      }

      if (window.matchMedia('(max-width: 950px)').matches){
        $('.site-header__search').removeClass('search-focus');
        $('.site-header .main-wrapper .search-header').removeClass('search--focus');
      }

      if (window.matchMedia('(max-width: 1150px)').matches){
          $('#AccessibleNav').height( $(window).height() - $('.header-section').height() ).css('overflow-y','scroll');
      } else{
          $('#AccessibleNav').removeAttr('style');
      }
	  
	  if (window.matchMedia('(min-width: 1151px)').matches){
		$('.spec-table-title .appended-desc').remove();
	  }
	  
	  

    });   

	
	$('.page-custom-wrapper .page-main-content .grid-view-item').matchHeight();
  
  $('.pushme').click( function() {
		    $("#white-transparent").toggleClass("enable-map");
		     $(this).text(function(i, v){
               return v === 'Enable Map' ? 'Disable Map' : 'Enable Map'
            })
		});

         $('#white-transparent').click( function() {
		    $(this).addClass("enable-map");
		     $('.pushme').text(function(i, v){
               return v === 'Disable Map' ? 'Disable Map' : 'Disable Map'
            })
		});


    var timer;

    $('#top-nav-section .top-nav > li').each(
        function(){
            var originialHTML = $('#SiteNav').html();
            var thisUL = $(this).children('.site-nav__dropdown').children('ul').html();
            var thisA = $(this);

            // bof - ASP-41
          	const handlerIn = function(e){
              e.preventDefault();
              $('#top-nav-section .top-nav > li').removeClass('active-state');
              thisA.addClass('active-state');
              $('#AccessibleNav').addClass('active-state');
              $('#SiteNav').html(thisUL);
              if(timer) {
                clearTimeout(timer);
              }

              if( $('body').hasClass('customcollection') ){
                $('#AccessibleNav').css('display','block');
                $('#PageContainer').css('padding-top','259px');
              }

            };
            const handlerOut = function(e) {
              e.preventDefault();
              //////////////////////
              // if( navigator.userAgent.indexOf("Firefox") > 0 ){
              //     console.log('firefox spotted');
              // } else {
              // console.log(idIsHovered('siteNav'));
              // if (idIsHovered('siteNav')) {
              //     console.log( '1' );
              // } else {
              //     console.log( '2' );
              // }

              $('#AccessibleNav').hover(
                function() {
                  // idIsHovered('AccessibleNav');
                }, function() {
                  thisA.removeClass('active-state');
                  $('#AccessibleNav').removeClass('active-state');
                  $('#SiteNav').html(originialHTML);
                }
              );
              //////////////////////
            };
            $(this)
            	.hover(handlerIn, handlerOut)
          		.on("touchstart", function (e) {
	                "use strict";
                	var link = $(this);
                	if (link.hasClass('hover')) {
                    	return true;
                	} else {
                    	link.addClass("hover");
                    	$('.hover').not(this).removeClass("hover");
                    	e.preventDefault();
                        handlerIn(e);
                    	return false;
                	}
            	});
          	// eof - ASP-41
        }
    );

  $('#click-here-to-save').click(function (e) {
    $('#basic-modal-content').modal({
      overlayClose : true,
      onClose: function (dialog) {
        dialog.data.fadeOut('fast', function () {
          dialog.container.fadeOut('fast', function () {
            dialog.overlay.fadeOut('fast', function () {
              $.modal.close(); // must call this!
            });
          });
        });
      },
      onOpen: function (dialog) {
        dialog.overlay.fadeIn('fast', function () {
          dialog.container.fadeIn('fast', function () {
            dialog.data.fadeIn('fast');
			//
			$('#mc-embedded-subscribe-form').on('submit', function(e){
				e.preventDefault();
				$('.loader').css('display','block');
				 var $form = $(this);
				$.ajax({
					type: $form.attr('method'),
					url: $form.attr('action'),
					data: $form.serialize(),
					cache       : false,
					dataType : 'jsonp',
					cache: false,
					jsonp: 'c', // trigger MailChimp to return a JSONP response
					contentType: 'application/json; charset=utf-8',
					error: function(err) { alert("Could not connect to the registration server. Please try again later."); },
					success     : function(data) {
						$('.loader').css('display','none');
						if (data.result != "success") {
							alert(data.msg);
						} else {
							localStorage.setItem("newsletter", "submitted");
							$('#mc_embed_signup_scroll').css('display','none');
							$('#mailchimp-form-success').css('display','block');
						}

					}
				});
				
			});
			//
			
          });
        });
      }
    });
    return false;
  });



  $('#enable-zoom-on-engrave').on('click', function(e){
    e.preventDefault();
    if($(this).hasClass('active_zoom') ){
      $(this).removeClass('active_zoom');
      $(this).text('Enable Zoom');
      //$('#zoom-fig').removeClass('hide');
      //$('#video-container').removeClass('hide');
	  $('#mainFrame').removeClass('hide');
      $('.frameWrap').removeClass('hide');
      $('#FeaturedImageZoom-product-template').removeClass('force_enable');
    } else {
      $(this).addClass('active_zoom');
      $(this).text('Disable Zoom');
      $('#zoom-fig').addClass('hide');
      $('#video-container').addClass('hide');
      $('.frameWrap').addClass('hide');
      $('#FeaturedImageZoom-product-template').addClass('force_enable');
    }

  });


  
  
});

$(function() {

    if( $('#productSelect-option-0').val() == 'Default Title' ){
        $('#productSelect-option-0').addClass('hide');
    }

    if( $('body').hasClass('pdftable') ) {

        $('#pdftable-control-grid').removeClass('active');
        $('#pdftable-control-table').addClass('active');
        $('.pdf-table-tabs').css('display','none');
        $('ul.pdf-table-display.pdf-table').removeClass('tabled').addClass('grid_layout');

        if( $('#main-pdftable-list').parent().is('div.pdf-table-mobile-wrapper')){} else{

            // ---
            // ASP-19 :: Fix Flashlight Feature Comparison Table
            createBarTitles();
            getBarTableTitlesWidths();
            // end/ASP-19

            var total_li_width = 0;
            $('#main-pdftable-list li.product-list').each( function(){
                total_li_width += $(this).width();
            });
            var total_li_all_width = 0;
            $('#main-pdftable-list li').each( function(){
                total_li_all_width += $(this).width();
            });

            $('#main-pdftable-list').width(total_li_width+1).wrap('<div class="pdf-table-mobile-wrapper"></div>');
            $('#main-pdftable-list2').width(total_li_all_width+1);
            $('#top-scroll-bar-pdf').width(total_li_all_width+3);

            $('.remove-matix-column').each( function(){
                $(this).on('click', function(e) {
                    e.preventDefault();
            
                    $('.product-list.product-list-'+ $(this).parent().parent().parent().data('matrix-id') + '').remove();
                    
                    // $('.lightmatix-data-specs .image-con').addClass('no-heading-bar');
                    // $('#sticky-header-light-matrix .pdf-table.grid_layout').css('padding-top','0');
                    // $('#main-pdftable-list2 .clone-pdf-table-title.tile-edc').remove();
                    // $('#main-pdftable-list2 .clone-pdf-table-title.tile-transitional').remove();
                    // $('#main-pdftable-list2 .clone-pdf-table-title.tile-duty').remove();
                    // $('#main-pdftable-list2 .clone-pdf-table-title.tile-strategic').remove();

                    // ---
                    // ASP-19 :: Fix Flashlight Feature Comparison Table
                    // after removing an item, calculate the width for all items again
                    getBarTableTitlesWidths();
                    // end/ASP-19

                    var total_li_width = 0;
                    $('#main-pdftable-list li.product-list').each( function(){
                        total_li_width += $(this).width();
                    });
                    var total_li_all_width = 0;
                    $('#main-pdftable-list li').each( function(){
                        total_li_all_width += $(this).width();
                    });
                    $('#main-pdftable-list').width(total_li_width+1);
                    $('#main-pdftable-list2').width(total_li_all_width+1);
                    $('#top-scroll-bar-pdf').width(total_li_all_width+3);

                    // $('#mobile-list-spec').addClass('remove-li-activate');
                    // $('#sticky-header-light-matrix').addClass('remove-li-activate');

                    if( $('#slide-to-see-right').hasClass('reload-active') ){ } else{
                        $('#slide-to-see-right').append('<a href="" javascript="window.reload()">Reset Chart</a>');
                    }
                    $('#slide-to-see-right').addClass('reload-active');

                    /********/
                    $('#printable-section').html('');

                    $("#main-pdftable-list").clone().each(function() {
                        $(this).find('.first-list').remove();
                        $(this).find('li').removeAttr('style');
                        var list = $(this);
                        var size = 9;
                        var current_size = 0;
                        var first_list = 1;
                        var more_list = 0;
                        list.children().each(function() {
                        if (++current_size > size) {
                            var new_list = $("<ul></ul>").insertAfter(list);
                            list = new_list;
                            current_size = 1;
                            first_list++;
                        }
                        list.append(this);
                        $('#printable-section').append(list);
                        });
                    });
                
                    $('#printable-section ul').removeAttr('id class style').addClass('grid_layout pdf-table').prepend( $('#main-pdftable-list li.first-list').html() );
                    $('#printable-section .spec-table-titles').wrap('<li class="first-list table-first"></li>');  
                    $('#printable-section .remove-matix-column').remove();
                
                    $('#printable-section .grid_layout.pdf-table li .wrap-in .wrap-image img').wrap('<div class="image-wrapper"></div>');
                    $('#printable-section .spec-table-title').addClass();
                    /* Height Fixer */
                    var ps_spec_1 = Math.max.apply(null, $('#printable-section .product-spec[data-spec-id="1"]').map(function (){ return $(this).height(); }).get());
                    $('#printable-section .product-spec[data-spec-id="1"]').height(ps_spec_1);
                    $('#printable-section .spec-table-title[data-spec-table-id="1"]').height(ps_spec_1);

                    var ps_spec_2 = Math.max.apply(null, $('#printable-section .product-spec[data-spec-id="2"]').map(function (){ return $(this).height(); }).get());
                    $('#printable-section .product-spec[data-spec-id="2"]').height(50);
                    $('#printable-section .spec-table-title[data-spec-table-id="2"]').height(50);

                    var ps_spec_3 = Math.max.apply(null, $('#printable-section .product-spec[data-spec-id="3"]').map(function (){ return $(this).height(); }).get());
                    $('#printable-section .product-spec[data-spec-id="3"]').height(50);
                    $('#printable-section .spec-table-title[data-spec-table-id="3"]').height(50);

                    var ps_spec_4 = Math.max.apply(null, $('#printable-section .product-spec[data-spec-id="4"]').map(function (){ return $(this).height(); }).get());
                    $('#printable-section .product-spec[data-spec-id="4"]').height(40);
                    $('#printable-section .spec-table-title[data-spec-table-id="4"]').height(40);

                    var ps_spec_5 = Math.max.apply(null, $('#printable-section .product-spec[data-spec-id="5"]').map(function (){ return $(this).height(); }).get());
                    $('#printable-section .product-spec[data-spec-id="5"]').height(40);
                    $('#printable-section .spec-table-title[data-spec-table-id="5"]').height(40);

                    var ps_spec_6 = Math.max.apply(null, $('#printable-section .product-spec[data-spec-id="6"]').map(function (){ return $(this).height(); }).get());
                    $('#printable-section .product-spec[data-spec-id="6"]').height(50);
                    $('#printable-section .spec-table-title[data-spec-table-id="6"]').height(50);

                    var ps_spec_7 = Math.max.apply(null, $('#printable-section .product-spec[data-spec-id="7"]').map(function (){ return $(this).height(); }).get());
                    $('#printable-section .product-spec[data-spec-id="7"]').height(60);
                    $('#printable-section .spec-table-title[data-spec-table-id="7"]').height(60);

                    var ps_spec_8 = Math.max.apply(null, $('#printable-section .product-spec[data-spec-id="8"]').map(function (){ return $(this).height(); }).get());
                    $('#printable-section .product-spec[data-spec-id="8"]').height(70);
                    $('#printable-section .spec-table-title[data-spec-table-id="8"]').height(70);

                    var ps_spec_9 = Math.max.apply(null, $('#printable-section .product-spec[data-spec-id="9"]').map(function (){ return $(this).height(); }).get());
                    $('#printable-section .product-spec[data-spec-id="9"]').height(ps_spec_9);
                    $('#printable-section .spec-table-title[data-spec-table-id="9"]').height(ps_spec_9);

                    var ps_spec_10 = Math.max.apply(null, $('#printable-section .product-spec[data-spec-id="10"]').map(function (){ return $(this).height(); }).get());
                    $('#printable-section .product-spec[data-spec-id="10"]').height(ps_spec_10);
                    $('#printable-section .spec-table-title[data-spec-table-id="10"]').height(ps_spec_10);

                    var ps_spec_11 = Math.max.apply(null, $('#printable-section .product-spec[data-spec-id="11"]').map(function (){ return $(this).height(); }).get());
                    $('#printable-section .product-spec[data-spec-id="11"]').height(70);
                    $('#printable-section .spec-table-title[data-spec-table-id="11"]').height(70);

                    var ps_spec_12 = Math.max.apply(null, $('#printable-section .product-spec[data-spec-id="12"]').map(function (){ return $(this).height(); }).get());
                    $('#printable-section .product-spec[data-spec-id="12"]').height(ps_spec_12);
                    $('#printable-section .spec-table-title[data-spec-table-id="12"]').height(ps_spec_12);

                    var ps_spec_13 = Math.max.apply(null, $('#printable-section .product-spec[data-spec-id="13"]').map(function (){ return $(this).height(); }).get());
                    $('#printable-section .product-spec[data-spec-id="13"]').height(ps_spec_13);
                    $('#printable-section .spec-table-title[data-spec-table-id="13"]').height(ps_spec_13);

                    var ps_spec_14 = Math.max.apply(null, $('#printable-section .product-spec[data-spec-id="14"]').map(function (){ return $(this).height(); }).get());
                    $('#printable-section .product-spec[data-spec-id="14"]').height(50);
                    $('#printable-section .spec-table-title[data-spec-table-id="14"]').height(50);

                    var ps_spec_15 = Math.max.apply(null, $('#printable-section .product-spec[data-spec-id="15"]').map(function (){ return $(this).height(); }).get());
                    $('#printable-section .product-spec[data-spec-id="15"]').height(ps_spec_15);
                    $('#printable-section .spec-table-title[data-spec-table-id="15"]').height(ps_spec_15);

                    var ps_spec_16 = Math.max.apply(null, $('#printable-section .product-spec[data-spec-id="16"]').map(function (){ return $(this).height(); }).get());
                    $('#printable-section .product-spec[data-spec-id="16"]').height(70);
                    $('#printable-section .spec-table-title[data-spec-table-id="16"]').height(70);
            
                });
            });
        
        }

  $('.spec-table-title .spec-question-mark').hover(
    function(){
      if( $(this).parent().find('.description').text() ){        
        $(this).parent().append('<div class="appended-desc">'+$(this).parent().find('.description').text()+'</div>');
      }
    },
    function(){ $('.appended-desc').remove(); }
  );
  
  $('.spec-table-title .spec-question-mark').each( function(){
	  $(this).on('click', function(e){
		  if (window.matchMedia('(max-width: 1150px)').matches){
			  
			  $('.spec-table-title .appended-desc').remove();
			  
			  if( $(this).parent().find('.description').text() ){    
				$(this).parent().append('<div class="appended-desc">'+$(this).parent().find('.description').text()+'</div>');
			  }
		  }
	  })
  });
  
  
  //$( "#main-pdftable-list2" ).clone().appendTo( "#printable-section" );
  
  $("#main-pdftable-list").clone().each(function() {
	$(this).find('.first-list').remove();
	$(this).find('li').removeAttr('style');
    var list = $(this);
    var size = 9;
    var current_size = 0;
	var first_list = 1;
	var more_list = 0;
    list.children().each(function() {
      if (++current_size > size) {
        var new_list = $("<ul></ul>").insertAfter(list);
        list = new_list;
        current_size = 1;
		first_list++;
      }
	  list.append(this);
      $('#printable-section').append(list);
    });
  });
  
  $('#printable-section ul').removeAttr('id class style').addClass('grid_layout pdf-table').prepend( $('#main-pdftable-list li.first-list').html() );
  $('#printable-section .spec-table-titles').wrap('<li class="first-list table-first"></li>');  
  $('#printable-section .remove-matix-column').remove();
  
  $('#printable-section .grid_layout.pdf-table li .wrap-in .wrap-image img').wrap('<div class="image-wrapper"></div>');
  $('#printable-section .spec-table-title').addClass();
  
  
  /* Height Fixer */
var ps_spec_1 = Math.max.apply(null, $('#printable-section .product-spec[data-spec-id="1"]').map(function (){ return $(this).height(); }).get());
$('#printable-section .product-spec[data-spec-id="1"]').height(ps_spec_1);
$('#printable-section .spec-table-title[data-spec-table-id="1"]').height(ps_spec_1);

var ps_spec_2 = Math.max.apply(null, $('#printable-section .product-spec[data-spec-id="2"]').map(function (){ return $(this).height(); }).get());
$('#printable-section .product-spec[data-spec-id="2"]').height(50);
$('#printable-section .spec-table-title[data-spec-table-id="2"]').height(50);

var ps_spec_3 = Math.max.apply(null, $('#printable-section .product-spec[data-spec-id="3"]').map(function (){ return $(this).height(); }).get());
$('#printable-section .product-spec[data-spec-id="3"]').height(50);
$('#printable-section .spec-table-title[data-spec-table-id="3"]').height(50);

var ps_spec_4 = Math.max.apply(null, $('#printable-section .product-spec[data-spec-id="4"]').map(function (){ return $(this).height(); }).get());
$('#printable-section .product-spec[data-spec-id="4"]').height(40);
$('#printable-section .spec-table-title[data-spec-table-id="4"]').height(40);

var ps_spec_5 = Math.max.apply(null, $('#printable-section .product-spec[data-spec-id="5"]').map(function (){ return $(this).height(); }).get());
$('#printable-section .product-spec[data-spec-id="5"]').height(40);
$('#printable-section .spec-table-title[data-spec-table-id="5"]').height(40);

var ps_spec_6 = Math.max.apply(null, $('#printable-section .product-spec[data-spec-id="6"]').map(function (){ return $(this).height(); }).get());
$('#printable-section .product-spec[data-spec-id="6"]').height(50);
$('#printable-section .spec-table-title[data-spec-table-id="6"]').height(50);

var ps_spec_7 = Math.max.apply(null, $('#printable-section .product-spec[data-spec-id="7"]').map(function (){ return $(this).height(); }).get());
$('#printable-section .product-spec[data-spec-id="7"]').height(60);
$('#printable-section .spec-table-title[data-spec-table-id="7"]').height(60);

var ps_spec_8 = Math.max.apply(null, $('#printable-section .product-spec[data-spec-id="8"]').map(function (){ return $(this).height(); }).get());
$('#printable-section .product-spec[data-spec-id="8"]').height(70);
$('#printable-section .spec-table-title[data-spec-table-id="8"]').height(70);

var ps_spec_9 = Math.max.apply(null, $('#printable-section .product-spec[data-spec-id="9"]').map(function (){ return $(this).height(); }).get());
$('#printable-section .product-spec[data-spec-id="9"]').height(ps_spec_9);
$('#printable-section .spec-table-title[data-spec-table-id="9"]').height(ps_spec_9);

var ps_spec_10 = Math.max.apply(null, $('#printable-section .product-spec[data-spec-id="10"]').map(function (){ return $(this).height(); }).get());
$('#printable-section .product-spec[data-spec-id="10"]').height(ps_spec_10);
$('#printable-section .spec-table-title[data-spec-table-id="10"]').height(ps_spec_10);

var ps_spec_11 = Math.max.apply(null, $('#printable-section .product-spec[data-spec-id="11"]').map(function (){ return $(this).height(); }).get());
$('#printable-section .product-spec[data-spec-id="11"]').height(70);
$('#printable-section .spec-table-title[data-spec-table-id="11"]').height(70);

var ps_spec_12 = Math.max.apply(null, $('#printable-section .product-spec[data-spec-id="12"]').map(function (){ return $(this).height(); }).get());
$('#printable-section .product-spec[data-spec-id="12"]').height(ps_spec_12);
$('#printable-section .spec-table-title[data-spec-table-id="12"]').height(ps_spec_12);

var ps_spec_13 = Math.max.apply(null, $('#printable-section .product-spec[data-spec-id="13"]').map(function (){ return $(this).height(); }).get());
$('#printable-section .product-spec[data-spec-id="13"]').height(ps_spec_13);
$('#printable-section .spec-table-title[data-spec-table-id="13"]').height(ps_spec_13);

var ps_spec_14 = Math.max.apply(null, $('#printable-section .product-spec[data-spec-id="14"]').map(function (){ return $(this).height(); }).get());
$('#printable-section .product-spec[data-spec-id="14"]').height(50);
$('#printable-section .spec-table-title[data-spec-table-id="14"]').height(50);

var ps_spec_15 = Math.max.apply(null, $('#printable-section .product-spec[data-spec-id="15"]').map(function (){ return $(this).height(); }).get());
$('#printable-section .product-spec[data-spec-id="15"]').height(ps_spec_15);
$('#printable-section .spec-table-title[data-spec-table-id="15"]').height(ps_spec_15);

var ps_spec_16 = Math.max.apply(null, $('#printable-section .product-spec[data-spec-id="16"]').map(function (){ return $(this).height(); }).get());
$('#printable-section .product-spec[data-spec-id="16"]').height(70);
$('#printable-section .spec-table-title[data-spec-table-id="16"]').height(70);

  console.log('append to print');

  }


  function calculateApplication(){
    console.log('calculating');
    var title_EDC = $('.container-container ul.pdf-table .tile-edc');
    console.log( title_EDC.width() );
  }

  if($('body').hasClass('pdftable')){ $('#PageContainer').removeClass('is-moved-by-drawer');

  $(window).scroll(function(e){

    var lightmatrixtop = $('#main-pdftable-list2').offset().top;
    console.log(lightmatrixtop);
	
    if ($(this).scrollTop() > 360){
		$('#pdftable-main-container').addClass('enable_sticky');
    }

    if ($(this).scrollTop() < 360){
      $('#pdftable-main-container').removeClass('enable_sticky');
    }
    // console.log( $(this).scrollTop() )  ;
  });

  }
  
  $(".pdf-table-mobile-wrapper").scroll(function(){
    $("#sticky-header-light-matrix").scrollLeft($(".pdf-table-mobile-wrapper").scrollLeft());
	$("#top-scroll-bar-wrapper").scrollLeft($(".pdf-table-mobile-wrapper").scrollLeft());
  });
  $("#sticky-header-light-matrix").scroll(function(){
    $(".pdf-table-mobile-wrapper").scrollLeft($("#sticky-header-light-matrix").scrollLeft());
	$("#top-scroll-bar-wrapper").scrollLeft($("#sticky-header-light-matrix").scrollLeft());
  });
  $("#top-scroll-bar-wrapper").scroll(function(){
    $(".pdf-table-mobile-wrapper").scrollLeft($("#top-scroll-bar-wrapper").scrollLeft());
	$("#sticky-header-light-matrix").scrollLeft($("#top-scroll-bar-wrapper").scrollLeft());
	
	// console.log('scrolling');
  });


  
  $('.pdf-table.grid_layout li.product-list').each(
	function(){
	$(this).hover(
	function(){
		$('.pdf-table.grid_layout li.product-list').removeClass('hovering');
		$(this).addClass('hovering');
		$('.pdf-table.grid_layout li.product-list-' + $(this).data('matrix-id') + '').addClass('hovering');
	}, function(){
		$(this).removeClass('hovering');
		$('.pdf-table.grid_layout li.product-list-' + $(this).data('matrix-id') + '').removeClass('hovering');
	});
	}
  );
  
  
  $('.product-spec').hover( function(){
	  $(this).addClass('spec_active');
	  $('.product-spec[data-spec-id="'+$(this).data('spec-id') + '"]').addClass('spec_hover');
  }, function(){
	  $(this).removeClass('spec_active');
	  $('.product-spec[data-spec-id="'+$(this).data('spec-id') + '"]').removeClass('spec_hover');
  } );
  
// following code disabled to avoid modal pop-up displaying on site load
/* 
 if( localStorage.getItem("newsletter") ){
	 console.log('pop-up filled');
 } else {
	 if( $('body').hasClass('customer-logged-in') ){
		 
	 } else{
		 if( $('body').hasClass('template-index') ){
			 console.log('pop-up not filled');
			  setTimeout( function(){
				$('#basic-modal-content').modal({
				  overlayClose : true,
				  onClose: function (dialog) {
					dialog.data.fadeOut('fast', function () {
					  dialog.container.fadeOut('fast', function () {
						dialog.overlay.fadeOut('fast', function () {
						  $.modal.close(); // must call this!
						});
					  });
					});
				  },
				  onOpen: function (dialog) {
					dialog.overlay.fadeIn('fast', function () {
					  dialog.container.fadeIn('fast', function () {
						dialog.data.fadeIn('fast');
						
						//			
						
						$('#mc-embedded-subscribe-form').on('submit', function(e){
							e.preventDefault();
							$('.loader').css('display','block');
							 var $form = $(this);
							$.ajax({
								type: $form.attr('method'),
								url: $form.attr('action'),
								data: $form.serialize(),
								cache       : false,
								dataType : 'jsonp',
								cache: false,
								jsonp: 'c', // trigger MailChimp to return a JSONP response
								contentType: 'application/json; charset=utf-8',
								error: function(err) { alert("Could not connect to the registration server. Please try again later."); },
								success     : function(data) {
									$('.loader').css('display','none');
									if (data.result != "success") {
										alert(data.msg);
									} else {
										localStorage.setItem("newsletter", "submitted");
										$('#mc_embed_signup_scroll').css('display','none');
										$('#mailchimp-form-success').css('display','block');
									}

								}
							});
							
						});
						//
						
					  });
					});
				  }
				});
			  }, 4000);
		 }
	 }
 }
 */
 
  if( $('#contact_form .form--success').text() ){
	 console.log('pop-up filled');
	 if (typeof(Storage) !== "undefined") {
		localStorage.setItem("newsletter", "submitted");
		$('.asp-modal-newsletter-title').css('opacity','0');
		$('.asp-modal-newsletter-content').css('opacity','0');
	 }
	 setTimeout( function(){
		$('#basic-modal-content').modal({
		  overlayClose : true,
		  onClose: function (dialog) {
			dialog.data.fadeOut('fast', function () {
			  dialog.container.fadeOut('fast', function () {
				dialog.overlay.fadeOut('fast', function () {
				  $.modal.close(); // must call this!
				});
			  });
			});
		  },
		  onOpen: function (dialog) {
			dialog.overlay.fadeIn('fast', function () {
			  dialog.container.fadeIn('fast', function () {
				dialog.data.fadeIn('fast');
				//
				$('#mc-embedded-subscribe-form').on('submit', function(e){
					e.preventDefault();
					$('.loader').css('display','block');
					 var $form = $(this);
					$.ajax({
						type: $form.attr('method'),
						url: $form.attr('action'),
						data: $form.serialize(),
						cache       : false,
						dataType : 'jsonp',
						cache: false,
						jsonp: 'c', // trigger MailChimp to return a JSONP response
						contentType: 'application/json; charset=utf-8',
						error: function(err) { alert("Could not connect to the registration server. Please try again later."); },
						success     : function(data) {
							$('.loader').css('display','none');
							if (data.result != "success") {
								alert(data.msg);
							} else {
								localStorage.setItem("newsletter", "submitted");
								$('#mc_embed_signup_scroll').css('display','none');
								$('#mailchimp-form-success').css('display','block');
							}

						}
					});
					
				});
				//
			  });
			});
		  }
		});
	  }, 4000);
  }
  
  
  function handle_mousedown(e){
		window.my_dragging = {};
		my_dragging.pageX0 = e.pageX;
		my_dragging.pageY0 = e.pageY;
		my_dragging.elem = this;
		my_dragging.offset0 = $(this).offset();
		function handle_dragging(e){
			var left = my_dragging.offset0.left + (e.pageX - my_dragging.pageX0);
			var dragger_right = ($(window).width() - ($('#dragger-pdf').offset().left + $('#dragger-pdf').outerWidth()));
			var dragger_width = ( $(window).width() - dragger_right) - 30;
			var top = 0;
			if( left > dragger_right && dragger_width > left ){
				$(my_dragging.elem).offset({left: left});
				top += left - dragger_right;
			}
			//var maxScrollLeft =  $('#main-pdftable-list').width() - $('.pdf-table-mobile-wrapper').width();
			$('#top-scroll-bar-wrapper').scrollLeft(top);
			
			
		}
		function handle_mouseup(e){
			$('body')
			.off('mousemove', handle_dragging)
			.off('mouseup', handle_mouseup);
		}
		$('body')
		.on('mouseup', handle_mouseup)
		.on('mousemove', handle_dragging);
	}
	$('#dragger').mousedown(handle_mousedown);
	
	$("#top-scroll-bar-wrapper").mCustomScrollbar({
		axis:"x",
		theme:"light-3",
		advanced:{autoExpandHorizontalScroll:true},
		callbacks :{
			whileScrolling : function(){
				var scrolling1 = $("#mCSB_1_container").css('left');
				var current_scroll = scrolling1.replace('-','').replace('px','');
				// console.log(current_scroll);
				$("#sticky-header-light-matrix").scrollLeft(current_scroll);
				$("#top-scroll-bar-wrapper").scrollLeft(current_scroll);
			}
		}
		
	});
	
	var hashtag_url = window.location.hash.substr(1);
	if(hashtag_url){
		console.log(hashtag_url);
		
		$('#' + hashtag_url + ' .faq-question').next().slideDown(200, function() {
			  $('html, body').delay('200').animate({
			  scrollTop: $('#' + hashtag_url + ' .faq-question').offset().top - 350
			  }, 200);
		});
	  
	  
		console.log(hashtag_url);
	}
	
	function setCookie(cname, cvalue) {
		if( checkCookie() ){
			localStorage.setItem("email_submitted", cvalue );
		} else{
			var email_submitted = getCookie("email_submitted");
			localStorage.setItem("email_submitted", cvalue + "," + getCookie('email_submitted') );
		}
	}

	function getCookie(cname) {
		return localStorage.getItem(cname);
	}
	function checkCookie() {
		
		var email_submitted = localStorage.getItem("email_submitted");
		
		if(email_submitted){
			var email_submitted = localStorage.getItem("email_submitted");
			var splitted_email = email_submitted.split(',');
			var submitted_email = $('#Email').val();
			
			for(var i = 0; i <splitted_email.length; i++) {
				if( submitted_email.toLowerCase() == splitted_email[i].toLowerCase() ){				
					if( $('#generated-form-error').text() ){ } else{
						$('#simplemodal-container').height( $('#simplemodal-container').height( ) + 40 );
						$('<div id="generated-form-error" class="form-error" style="padding: 5px;font-size: 12px;text-align: center;max-width: 335px;">The email address you entered is already signed up</div>').insertAfter( '#Email' );
					}
					return true;
				}
			}
		}
	}
	
	
	$('.asp-modal-newsletter-form #contact_form').on('submit', function(e){
		
		if( checkCookie() ){
			return false;
		}
		
		if( $('#Email').val() ){
			setCookie( 'email_submitted', $('#Email').val() );
			console.log(getCookie("email_submitted"));
			console.log('submit');
			return true;
		}
		return false;
		
	});
	
	$('.tooltip-engrave-q').on('click', function(){
		if (window.matchMedia('(max-width: 1150px)').matches){
			$(this).find('.tooltip-asp-engrave').toggle();
		}
	});

	if( $('.page-content #contact_form .form--success').text() ){
		$("html, body").animate({ scrollTop: 0 }, 200);
	}
  
    var $sTop = $(document).scrollTop(),
        $header = jQuery("#shopify-section-header"),
        $headerHeight = $header.outerHeight();

    jQuery(window).scroll(function() {

      var kaydirma_cubugu = $(document).scrollTop();

      if (kaydirma_cubugu > $headerHeight) {
        $header.addClass('gizle');
      }  else {
        $header.removeClass('gizle');
      }

      if (kaydirma_cubugu > $sTop) {
        $header.removeClass('sabit');
      } else {
        $header.addClass('sabit');
      }

      $sTop = $(document).scrollTop();
    });
    
});

// ---
// ASP-19 :: Fix Flashlight Feature Comparison Table
function createBarTitles() {
    var tableFirstList = $('#main-pdftable-list2 li.first-list');
    tableFirstList.append('<div class="bar-table-titles" id="bar-table-titles" style="display: flex; position: absolute; left: 87px; top: 0;">');
    var tableBarTitles = tableFirstList.find('.bar-table-titles');
    tableBarTitles.append('<div style="position: static;" class="clone-clone-pdf-table-title clone-pdf-table-title tile-edc">EDC (Every Day Carry)</div>');
    tableBarTitles.append('<div style="position: static;" class="clone-pdf-table-title tile-transitional">TRANSITIONAL</div>');
    tableBarTitles.append('<div style="position: static;" class="clone-clone-pdf-table-title clone-pdf-table-title tile-duty">DUTY</div>');
    tableBarTitles.append('<div style="position: static;" class="clone-pdf-table-title tile-strategic">STRATEGIC</div>');
}

function getBarTableTitlesWidths() {
    var titles = ['edc', 'transitional', 'duty', 'strategic'];

    jQuery.each(titles, function(i, name) {
        jQuery( '.tile-'+ name +'' ).css( 'width', calculateBarTitleWidth( '#main-pdftable-list2 .pdftable-content-'+ name +'' ) );
    });
}

function calculateBarTitleWidth( els ) {
    var groupWidth = 0;
    jQuery(els).each(function() {
        groupWidth += jQuery(this).width();
    });
    return groupWidth;
}
// end/ASP-19

$('.js-cop-tooltip-trigger').tooltip({
  content: function () {
    return $(this).find('.js-cop-tooltip__container').html();
  },
  disabled: true,
  items: '.js-cop-tooltip-trigger',
  track: true,
  position: {
      at: 'center bottom',
      my: 'left top+5px',
  },
  tooltipClass: "cop-tooltip-active"
});

$('.js-cop-tooltip-trigger').hover(function() {
  $('.js-cop-tooltip-trigger').tooltip('open');
});


$('.js-cop-tooltip-trigger').on('click touchend', function(ev) {
  ev.preventDefault();
  ev.stopPropagation();
  $('.js-cop-tooltip-trigger').tooltip('open');
  $('body').on('click touchend', function(ev) {
    $('.js-cop-tooltip-trigger').tooltip('close');
  });
});

